import type { Transaction } from '@shared/transactions-types';
import type { Amount } from '@shared/core-types';

import type { TransactionPredicate } from './types';
import { hasField } from './hasField';

export type AmountProperty = keyof {
    [P in keyof Transaction as Transaction[P] extends Amount | null | undefined ? P : never]: any;
};

export const hasNonZeroAmount =
    (field: AmountProperty): TransactionPredicate =>
    (transaction: Transaction) =>
        hasField(field)(transaction) && Boolean(transaction[field]?.value);
